import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Regla de precios inteligentes global de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Regla de precios inteligentes maestra de {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.menu]: 'Regla de precios inteligentes del menú {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.category]: 'Regla de precios inteligentes de la categoría {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.product]: 'Regla de precios inteligentes del producto {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Regla de precios inteligentes del grupo de modificadores {{name}}',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Regla de precios inteligentes del modificador {{name}}',
  },
  labels: {
    new: 'Nuevo',
    base_price: 'Precio base de {{name}}: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menú',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Categoría',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Producto',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Grupo de modificadores',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modificador',
      placeholder: 'Seleccionar {{resource}}',
    },
    order_methods: {
      label: 'Métodos de pedido',
      placeholder: 'Seleccionar métodos de pedido a los que se aplica la regla',
      options: {
        [ORDER_METHODS.pickup]: 'Recogida',
        [ORDER_METHODS.delivery]: 'Entrega',
        [ORDER_METHODS.room_service]: 'Servicio en habitación/mesa',
      },
    },
    modifier_type: {
      label: 'Tipo de modificador de precio',
      placeholder: 'Seleccionar tipo de modificador de precio',
      disabled_tooltip:
        'El valor absoluto no está disponible para reglas de menú completo porque sobrescribiría el precio de cada artículo.',
      tooltip: {
        title: 'El tipo de modificador define cómo se modifican los precios',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Absoluto: sobrescribe el precio del recurso con el valor del modificador especificado',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Porcentaje: suma/resta el porcentaje del modificador especificado al precio base del recurso según el signo del valor',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Valor fijo: suma/resta el valor fijo del modificador especificado al precio base según el signo del valor',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absoluto',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Porcentaje',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Valor fijo',
      },
    },
    modifier_value: {
      label: 'Valor del modificador de precio',
    },
    round: {
      label: 'Redondear el precio resultante',
      tooltip:
        'Redondea el precio resultante al alza en 10 (p. ej. 14,91; 14,93; 14,99 pasan a ser 15,00). Útil principalmente para reglas de porcentaje',
    },
    is_visible: {
      label: 'Mostrar al cliente como oferta',
    },
    name: {
      label: 'Nombre',
      placeholder: 'Introducir nombre descriptivo para el cliente',
      default: '{{value}} de descuento en {{resource}}',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados correctamente',
  },
};
